<template>
	<v-container fluid>
		<v-row align="center">
			<v-progress-circular indeterminate v-if="loading" class="my-orange mx-auto"></v-progress-circular>
		</v-row>

		<v-row justify="center" align="center"
			style="position: sticky;  top: 0px; background-color: rgb(255, 255, 255); z-index: 5; box-shadow: 0px 4px 7px -4px rgba(0, 0, 0, 0.5);">
			<v-col cols="12" class="d-flex flex-row align-center">
				<v-autocomplete clearable :filter="customFilter" :items="legislacoes" :search-input.sync="search"
					:loading="loading" solo v-model="strSearchLegiscao" item-text="nome_lei" item-value="id_lei"
					color="#F15A24" outlined class=" mx-auto py-1 d-flex align-center justify-center" style="
                background-color: transparent;
                border-radius: 100px;
                
              " placeholder="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
					hint="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)" hide-details
					label="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)">
					<template v-slot:no-data>
						<v-list-item>
							<v-list-item-title>
								Pesquise pelo número ou palavra da ementa da
								<strong>legislação</strong>
							</v-list-item-title>
						</v-list-item>
					</template>
					<template v-slot:item="{ item }">
						<!-- <v-list-item-avatar
                                    color="indigo"
                                    class="text-h5 font-weight-light white--text"
                                    >
                                        {{ item.nome_lei.charAt(0) }}
                                    </v-list-item-avatar> -->
						<v-list-item-content style="max-width: 60%">
							<v-list-item-title v-html="highlight(item.numero_lei, search)"></v-list-item-title>
							<div class="text--primary mb-4" v-html="highlight(item.nome_lei, search)"></div>
							<!-- <v-list-item-subtitle v-html="item.nome_lei"></v-list-item-subtitle> -->
						</v-list-item-content>
						<v-list-item-action>
							<!-- <v-icon>mdi-bitcoin</v-icon> -->
						</v-list-item-action>
					</template>
				</v-autocomplete>
				<v-btn class="ml-3 "  color="#F15A24" dark>Nova Legislação</v-btn>
			</v-col>
			<!-- <v-col cols="12" md="11" class="align-center justify-center d-flex" style="gap: 1rem">
				<v-text-field hide-details="true" v-model="buscaModel" style="max-width: 450px" outlined color="#f15a24"
					label="Faça uma busca por algum termo específico"></v-text-field>
				<v-btn class="" style="
						background-color: #f15a24;
						color: #ffffff;
						text-transform: none;
					" @click="buscarLei">
					Buscar
					<v-icon> mdi-magnify </v-icon>
				</v-btn>
			</v-col> -->
			<!-- <v-col cols="12" md="2">
				<v-btn @click="addToVadeMecum">
                      Adicionar a Vade Mecum
                    </v-btn>
			</v-col> -->
			<v-col cols="12" md="12" class="d-flex align-center w-100 justify-space-between">
				<h2 class="my-orange gt-bold mb-0">{{ lei.numero_lei }}</h2>
				<p style="font-weight:bold"> {{ lei.status_lei ? "PUBLICADO" : "RASCUNHO"}}</p>
			</v-col>

			<!-- <v-col cols="12" md="6">
				<v-row>
					<v-col>
						<v-img v-if="lei.imagem_lei != ''" :src="lei.imagem_lei" height="250"></v-img>
						<v-img contain src="../assets/semimagem.png" height="250"></v-img>
					</v-col>
				</v-row>
			</v-col> -->

			<v-col cols="12" md="12">
				<p class="font-weight-light">{{ lei.nome_lei }}</p>
			</v-col>
			<v-col cols="12" class="d-flex justify-end">
				<!-- <v-btn class="mr-1">Nova Lei</v-btn> -->
				<v-btn class="mr-2" small><v-icon>mdi-plus</v-icon>Novo Conteudo</v-btn>
				<v-btn @click="salvarLei" small><v-icon>mdi-content-save</v-icon>Salvar Lei</v-btn>

			</v-col>
		</v-row>
		<v-row>

		

		</v-row>
		<v-row>
			<v-col>
				<DynamicScroller id="conteudos" ref="conteudos" class="scroller" :items="conteudos" key-field="id_reg"
					:min-item-size="54">
					<!-- <v-virtual-scroll ref="conteudos" :items="conteudos" :height="`500px`" :itemHeight="210"> -->
					<template v-slot:default="{ item, index, active }">
						<DynamicScrollerItem :item="item" :data-index="index" :active="active" :size-dependencies="[
				item.conteudo
			]">
							<v-col class="rowAnnotation" cols="12">
								<p v-html="item.conteudo" :id="item.id_reg"></p>
								<div>
									<p class="d-flex justify-end">
										Registro #<b>{{ item.id_reg }}</b> <br>
									</p>
									<p class="d-flex align-center justify-end">
										Posicão 
										<!-- {{ item.sort }}  -->
										<v-text-field color="#F15A24" style="max-width:80px" class="ml-3" v-model="index" :disabled="!item.edit"></v-text-field>
										<v-icon v-if="!item.edit" @click="item.edit=true;item.sort=index">mdi-pencil</v-icon>
										<v-icon v-if="item.edit" color="#F15A24" @click="saveItem(item, index); item.edit=false">mdi-check</v-icon>
									
									</p>
								</div>
							</v-col>
						</DynamicScrollerItem>
					</template>
				</DynamicScroller>
				<!-- </v-virtual-scroll> -->
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<label class="tag-sm mx-1" v-for="(t, i) in lei.tags" :key="i">
					<input type="checkbox" disabled class="tag-sm-checkbox" />
					<span class="tag-sm-container">
						<span class="tag-sm-content">
							<span>{{ t }}</span>
							<span class="tag-sm-icon"></span>
						</span>
					</span>
				</label>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<p class="font-weight-light">
					Fonte:
					<span class="my-orange"> {{ lei.esfera_lei }}</span>
				</p>
			</v-col>
		</v-row>
		<v-divider class="my-5 mb-7" color="#f57029"></v-divider>


		<v-dialog width="700px" v-model="showBusca">
			<v-card class="px-5">
				<v-card-title class="px-0">Busca interna - {{ buscaModel }} <v-spacer />
					<v-btn @click="showBusca = false" text><v-icon large>mdi-close</v-icon></v-btn></v-card-title>
				<v-card-text>
					<p v-for="l in resultadoBusca" :key="l.id_reg">
						{{ l.conteudo }} <v-btn @click="gotoRef(l.id_reg)" text color="#f15a24">Ir até <v-icon
								color="#f15a24" small>mdi-arrow-down-right</v-icon></v-btn>
					</p>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="confirm" width="25vw">
			<v-card>
				<v-card-title>
					Remover Anotação
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" md="12">
							<h2 style="gap: 1rem; color: #F15A24">
								<v-icon>mdi-account-trash</v-icon>Você tem certeza que deseja remover está anotação
								?<br />
								<small class="black--text text-caption">Obs: Está ação é irreversível. </small>
							</h2>
						</v-col>
					</v-row>

				</v-card-text>
				<v-card-actions class="justify-end">
					<v-btn text @click="confirm = false"> Cancelar </v-btn>

					<v-btn color="#F15A24" :loading="loadingDelete" @click="deleteAnnotation()" dark> Remover </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-container>
</template>
<style scoped>
.scroller {
	height: 800px;
	overflow-y: auto;
	/* border: 2px dashed rgba(132, 8, 8, 0.406); */
}

#map {
	position: fixed;
	top: 110px;
	right: 0;
	width: 80px;
	min-width: 80px;
	height: 100%;
	z-index: 100;
}

a {
	color: #f15a24;
}

.rowHovered {
	/* border-radius: 2px; */
	/* border: 1px solid #f15a24; */
	cursor: pointer;
	background-color: #f7f7f7;
}

.annotation {
	background-color: #f15a2405;
	/* border: 1px dashed #f15a24; */
}

.rowAnnotation:hover {
	cursor: pointer;
	background-color: #f7f7f7;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
	max-width: 100% !important;
}

.annotation ::v-deep iframe {
	height: 250px;
}

.annotation p {
	margin-bottom: 0px !important;
}
</style>
<script>
// import pagemap from "pagemap";
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
	name: "Crawler",
	components: { DynamicScroller, DynamicScrollerItem },
	data() {
		return {
			legislacoes: [],
			strSearchLegiscao: "",
			search: "",
			idAnotacao: '',
			panel: [],
			isActive: false,
			files: [],
			annotation: { status: "private", texto: "" },
			delAnnotation: {},
			annotationVisible: "",
			anotacoes: [],
			showBusca: false,
			resultadoBusca: [],
			confirm: false,
			buscaModel: "",
			showNewAnnotation: false,
			conteudoSelected: {},
			conteudos: [],
			comentarios: {},
			avatar: {},
			comentario: "",
			idLei: 0,
			loading: false,
			loadingNewAnnotation: false,
			loadingDelete: false,
			lei: {},

			statusAnnotation: [
				{ text: "Público", value: "published" },
				{ text: "Grupo", value: "group" },
				{ text: "Privado", value: "private" },
				{ text: "Apenas Amigos", value: "friend" },
				{ text: "Arquivado", value: "archived" },
			],
			customToolbar: [
				[{ font: [] }, { size: [] }],
				["bold", "italic", "underline", "strike"],
				[{ color: [] }, { background: [] }],
				// [{ script: "super" }, { script: "sub" }],

				[
					{ list: "ordered" },
					{ list: "bullet" },
					{ indent: "-1" },
					{ indent: "+1" },
				],
				["direction", { align: [] }],
				["link", "image", "video"],
				["clean"],
			],
			customToolbar1: [
				[{ font: [] }, { size: [] }],
				["bold", "italic", "underline", "strike"],
				[{ color: [] }, { background: [] }],
				// [{ script: "super" }, { script: "sub" }],
				// [{ header: "1" }, { header: "2" }, "blockquote"],

				[
					{ list: "ordered" },
					{ list: "bullet" },
					{ indent: "-1" },
					{ indent: "+1" },
				],
				["direction", { align: [] }],
				["link", "image", "video"],

				["clean"],
			],
		};
	},
	async created() {
		this.loadLegislacoes()
		this.idLei = this.$route.params.idLei;
		if (this.idLei) {
			this.loadLei()
		}
	},
	watch: {
		strSearchLegiscao(nValue) {
			if (nValue) {
				this.idLei = nValue
				this.loadLei();
			}
		},
	},
	mounted() {
		// pagemap(document.querySelector("#map"), {
		// 	viewport: null,
		// 	styles: {
		// 		p: "rgba(0,0,0,0.08)",
		// 		".annotation": "#F15A24",
		// 		"h2,h3,h4": "rgba(0,0,0,0.08)",
		// 	},
		// 	back: "rgba(0,0,0,0.02)",
		// 	view: "rgba(0,0,0,0.05)",
		// 	drag: "rgba(0,0,0,0.10)",
		// 	interval: 50,
		// });
	},
	computed: {
		user() {
			return this.$store.state.user
		},
		groups() {
			return this.$store.state.user.grupos
		},
		editor() {
			return this.$refs.editor.quill;
		},
		intBreakPoint() {
			switch (this.$vuetify.breakpoint.name) {
				case "xs":
					return 0;
				case "sm":
					return 1;
				case "md":
					return 2;
				case "lg":
					return 3;
				case "xl":
					return 4;
				default:
					return 0;
			}
		},
	},
	methods: {
		async salvarLei() { 
			let conteudosSort = this.conteudos.map((e,i) => ({id_reg:e.id_reg, sort:i}))
			// window.console.log(conteudosSort)
			await this.$http.patch(`/items/leis/${this.idLei}`, {
				conteudo: { 
					update: conteudosSort
				}
			})
			this.loadLei()
		},
		saveItem(item, index) { 
			// window.console.log({item,index})
			this.conteudos.splice(item.sort,1)
			this.conteudos.splice(index, 0, item)
		},
		loadLei() {
			this.loading = true;
			this.$http({ url: "items/leis/" + this.idLei }).then((data) => {
				this.lei = data.data.data;
			});
			this.$http({
				url:
					"items/conteudoleis/?limit=-1&sort=sort,id_reg&filter[id_lei][_eq]=" +
					this.idLei,
			}).then((data) => {
				// window.console.log(data.data.data)
				this.conteudos = data.data.data;
				// this.reloadAnotacoes();
				// this.reloadComentarios();
				this.loading = false;
			});
		},
		async loadLegislacoes() {
			this.loading = true;
			let search = "";
			// this.strSearchLegiscao === undefined || this.strSearchLegiscao === null ? "" : `search:"${this.strSearchLegiscao}",`;
			const query = `query FilterByApelidosLeis {
                leis(${search} sort:["-data_lei"],
                        limit: 3000,
                        offset: 0) {
                    id_lei
                    numero_lei
                    data_lei
                    nome_lei
                }
                leis_aggregated${search === "" ? `` : `(${search})`} {
                    count { id_lei }
                }
            }`;
			// const variables = { user_id: this.user.id };
			const {
				data: { data },
			} = await this.$http.post("https://api.mylegis.com.br/graphql", {
				query,
				// variables,
			});
			this.legislacoes = data.leis;
			this.loading = false;
			// window.console.log(data.leis)
		},
		customFilter(item, queryText) {
			if (
				queryText.length > 4 &&
				!isNaN(queryText) &&
				queryText.indexOf(".") == -1
			) {
				queryText = queryText.replace(/(\d)(?=(\d{3})+$)/g, "$1.");
				this.search = queryText.replace(/(\d)(?=(\d{3})+$)/g, "$1.");
			}
			const textOne = item.nome_lei.toLowerCase();
			const textTwo = item.numero_lei.toLowerCase();
			const searchText = queryText.toLowerCase();

			return (
				textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
			);
		},

		gotoRef(refName) {
			var position = refName - this.conteudos[0].id_reg;
			// window.console.log(refName)
			// // var top = document.getElementById(refName);
			// window.console.log({refName, position})
			// window.console.log(this.conteudos[0].id_reg)
			// window.console.log(this.$refs )

			// this.$refs.conteudos.$el.scrollTo({ top: position * 100, behavior: "smooth" })
			this.$refs.conteudos.scrollToItem(position)
			this.showBusca = false
			window.scrollTo({ top: 200, behavior: "smooth" });
		},

		buscarLei() {
			this.$http.get(`items/conteudoleis/?search=` + this.buscaModel + `&filter[id_lei][_eq]=` +
				this.idLei).then(res => {
					this.resultadoBusca = res.data.data
					this.showBusca = true
				})
		},

		highlight(content, query) {
			if (!query) {
				return content;
			}
			return content.replace(new RegExp(query, "gi"), (match) => {
				return '<span class="my-orange">' + match + "</span>";
			});
		},

	},
};
</script>
